import { render, staticRenderFns } from "./BackupDeviceDetail.vue?vue&type=template&id=79884346&scoped=true"
import script from "./BackupDeviceDetail.vue?vue&type=script&lang=js"
export * from "./BackupDeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./BackupDeviceDetail.vue?vue&type=style&index=0&id=79884346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79884346",
  null
  
)

export default component.exports